import { MAuswahlwert } from "../../../metamodell";
import { AuswahlAccessor } from "../Auswahl";

export function AufsatzLeistenOptionen() {
  return (
    <div key="aufsatz-tabs" className="options-tab">
      <AufsatzleistenTab />
    </div>
  );
}

export function AufsatzleistenTab() {
  const agt = APP.arrangement;
  const { möglicheAuswahlwerte } = agt.auswahlAccessoren.Aufsatzleiste;
  const auswahlwert: MAuswahlwert = agt.aufsatzleisteAuswahlwert ?? möglicheAuswahlwerte[0];

  return (
    <fieldset>
      <legend className="sr-only">{I18N("Aufsatzleiste")}</legend>
      <div
        className="flex column-container"
        data-group-key="Aufsatzleisten"
        data-select-key="Aufsatzleisten"
        data-value={auswahlwert?.Key}
      >
        <AuswahlAccessor accessorKey="Aufsatzleiste" />
      </div>
    </fieldset>
  );
}
